const PUBLIC_ROUTES = ["/login", "/"];

export const storeRedirectPath = () => {
  const { pathname, search } = window.location;
  const path = pathname + search;

  // 🚫 don't store public routes
  if (PUBLIC_ROUTES.includes(pathname)) {
    return;
  }

  // ✅ store ONLY if route starts with `/shared/`
  const isSharedRoute = /^\/shared\/.+/.test(pathname);

  if (!isSharedRoute) {
    return;
  }

  sessionStorage.setItem("redirect_after_login", path);
};

export const getRedirectPath = () => {
  return sessionStorage.getItem("redirect_after_login");
};

export const clearRedirectPath = () => {
  sessionStorage.removeItem("redirect_after_login");
};
